import { render, staticRenderFns } from "./BusinessContacts.vue?vue&type=template&id=45fa28e2&scoped=true"
import script from "./BusinessContacts.vue?vue&type=script&lang=js"
export * from "./BusinessContacts.vue?vue&type=script&lang=js"
import style0 from "./BusinessContacts.vue?vue&type=style&index=0&id=45fa28e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa28e2",
  null
  
)

export default component.exports